export default "__VITE_ASSET__e75373a0__"